<template>
  <div>
    <QS-h4-title title="选择方案" />
    <el-form ref="formRef" :model="formModel" :rules="formRules" class="mt16 form-box" label-position="top">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="门店" prop="storeId">
            <template v-if="isECommerce || isRenew">
              <span>{{ formModel.storeName || '--' }}</span>
            </template>
            <QS-select
              v-else
              v-model="formModel.storeId"
              placeholder="请选择门店"
              filterable
              :option-data="storeOptions"
              :option-config="{
                labelKey: 'name',
                valueKey: 'id'
              }"
              @change="storeChanged">
            </QS-select>
            <div class="mt8" v-if="!isECommerce && !isRenew">
              <el-link  type="primary" :underline="false" @click="goToCreateStore">
                找不到门店?点击新增
              </el-link>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁类型" prop="rentCategory">
            <template slot="label">
              <label>租赁类型</label>
              <el-tooltip effect="dark" placement="top" style="margin-left: 4px">
                <i class="QS-icon-question-outline"></i>
                <template #content>
                  <span v-html="CATEGORY_CODE_DESCRIPTION"></span>
                </template>
              </el-tooltip>
            </template>
            <template v-if="isECommerce">
              <span>{{ CATEGORY_LIST[formModel.rentCategory] }}</span>
            </template>
            <el-select
              v-else
              v-model="formModel.rentCategory"
              placeholder="请选择"
              @change="rentCategoryChanged">
              <el-option
                v-for="(item,index) in categoryList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁方案" prop="planId">
            <template v-if="isECommerce">
              <span>【商城单】{{ formModel.planName }}</span>
            </template>
            <QS-select
              v-else
              popper-class="plan-rent-select-list"
              v-model="formModel.planId"
              placeholder="请选择"
              filterable
              :disabled="!planIdEnabled"
              :option-data="planOptions"
              :option-config="{
                labelKey: 'name',
                valueKey: 'id'
              }"
              @change="planChanged">
            </QS-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="租赁起始日" prop="startDate">
            <el-date-picker
              v-model="formModel.startDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="startPickOptions"
              @change="startDateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="form-box__periods" style="position: relative">
            <el-form-item
              :prop="formModel.isEndDateMode ? 'endDate' : 'rentPeriod'"
              class="form-box__periods__input"
            >
              <div slot="label" style="width: 100%;">
                <span>{{ formModel.isEndDateMode ? '租赁结束日' : '租期' }}</span>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handleSelectEndDate"
                  class="select-recent-mode"
                >
                  {{ formModel.isEndDateMode ? '选择租期' : '选择租赁结束日' }}
                </el-link>
              </div>
              <template v-if="formModel.isEndDateMode">
                <el-date-picker
                  v-model="formModel.endDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="endDatePickerOptions"
                  @change="onEndDateChange"
                  style="width: 100%"
                />
              </template>
              <template v-else-if="formModel.rentPeriodType === RENT_PERIOD_TYPE.MONTH">
                <el-input
                  v-model="formModel.rentPeriod"
                  v-integerNumber="{
                    min: 1,
                    max: 60,
                  }"
                  key="rentPeriod-type-month"
                  placeholder="请输入月数"
                  @change="rentPeriodChange" />
              </template>
              <template v-else>
                <el-input
                  v-model="formModel.rentPeriod"
                  v-integerNumber="{
                    min: 1,
                    max: 365,
                  }"
                  key="rentPeriod-type-day"
                  placeholder="请输入天数"
                  @change="rentPeriodChange" />
              </template>
            </el-form-item>
            <el-form-item class="form-box__periods__select" v-if="!formModel.isEndDateMode">
              <el-select v-model="formModel.rentPeriodType" @change="rentPeriodTypeChange" :disabled="isECommerce">
                <el-option :value="3" label="个月"></el-option>
                <el-option :value="1" label="天"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="赠送天数" prop="presentDays" class="presentDays-item">
            <el-input
              v-model="formModel.presentDays"
              placeholder="请输入0~365之间的数字"
              v-integerNumber="{
                min: 0,
                max: 365,
              }">
              <span slot="append">天</span>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item :label="payModeLabel" prop="payMode">
            <template v-if="payModeText.isText">
              {{ payModeText.text }}
            </template>
            <el-select
              v-else
              v-model="formModel.payMode"
              placeholder="请选择"
              @change="payModeChange">
              <el-option v-for="item in payModeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="isRenew">
          <el-form-item label="是否平移原订单押金" prop="isTranDeposit">
            <div slot="label" class="form-box__deposit">
              <label>是否平移原订单押金</label>
              <el-tooltip effect="dark" placement="top" style="margin-left: 4px">
                <i class="QS-icon-question-outline"></i>
                <template #content>
                  <span v-html="TRANSFER_DEPOSIT_TEXT"></span>
                </template>
              </el-tooltip>
              <span>{{ depositReceivedText }}</span>
            </div>
            <el-radio-group v-model="formModel.isTranDeposit" :disabled="disableDeposit" @change="depositChange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <ChooseContractTemplate
            :defaultValue="defaultTemplate"
            :showBtn="!isECommerce"
            @saveSuccess="setTemplateIdAndAIResultInfo"
            label="租赁合同模板"
            source="personalSignContract"
            ref="contractTemplateDialogRef" />
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>
<script setup>
import { ref, computed, onMounted, reactive, onUnmounted, watch, nextTick } from 'vue'
import moment from 'moment'
import { Message } from '@qs/ui'
import { useFormSync, useDictParseList } from '@/utils/useUtils.js'
import { useStore } from '@/store/hooks'
import { storeList, storeDetail } from '@/api/domain/shop.js'
import { getLeasingSchemeConfigListAll } from '@/api/domain/cars.js'
import {
  getRentPlanConfig,
  calculateContractEndData,
  calculateDays,
  getPreviewedPlan,
  getAccruedPlanStatistic,
  payPlanPreview } from '@/api/domain/orders.js'
import ChooseContractTemplate from '@/components/ChooseContractTemplate'
import WindowCommunication from '@/utils/windowCommunication'
import { miniStore } from '@/miniStore'
import { isEmpty } from 'lodash'
import { RENT_TYPE } from '@/components/RentPlanConfig/config'
import {
  onSetFee,
} from '../config'
import {
  PAY_MODE,
  PAY_MODE_TEXT,
  PAY_MODE_BY_DRIVER_COOPERATION,
  PAY_MODE_BY_DRIVER_COOPERATION_TEXT,
  RENT_PERIOD_TYPE,
  CATEGORY_CODE_MAP,
  CATEGORY_FEE_TYPE,
  CATEGORY_CODE_DESCRIPTION,
  ORDER_SOURCE,
  TRANSFER_DEPOSIT_TEXT,
  FEE_CODE_MAP,
  CATEGORY_LIST,
} from '@/config/rentConfig'

import * as Sentry from '@sentry/vue'
// 引入队列工具类
import AsyncQueue from '@/utils/asyncQueue'
import { quick } from '@/utils/ba'
import { trackClick } from '@/utils/trackReport'

const store = useStore()

const categoryList = computed(() => store.state.global.categoryList)

const props = defineProps({
  isRenew: {
    type: Boolean,
    default: false,
  },
  getDriverCooperFormData: {
    type: Function,
  },
})

// 创建支付计划生成队列（全局唯一，确保串行执行）
const payPlanQueue = ref(new AsyncQueue())

// 正在生成支付计划（状态联动队列）
const isRequestPlans = ref(0) // 0-初始 1-执行中 2-空闲（无排队）

const isGetEndDate = ref(false) // 正在获取合同截止日期

const { formModel } = useFormSync('step0')


const formRules = {
  storeId: [{ required: true, message: '请选择门店', trigger: 'change' }],
  rentCategory: [{ required: true, message: '请选择租赁类型', trigger: 'change' }],
  planId: [{ required: true, message: '请选择租赁方案', trigger: 'change' }],
  payMode: [{
    required: true,
    validator: (rule, value, callback) => {
      if (!value) {
        // 动态生成错误文案
        callback(new Error(`请选择${payModeLabel.value}`))
      } else {
        callback()
      }
    },
    trigger: 'change',
  }],
  startDate: [{ required: true, message: '请选择租赁起始日', trigger: 'change' }],
  rentPeriod: [{ required: true, message: '请输入期数', trigger: 'blur' }],
  endDate: [{ required: true, message: '请选择租赁结束日', trigger: 'change' }],
}

const feeTableData = ref([])

// 表单引用
const formRef = ref(null)

// 选项数据
const storeOptions = ref([])

const planOptions = ref([{ id: 0, name: '自定义' }])

const contractTemplateDialogRef = ref(null)

// 各个租赁类型对应的费项列表
const feeList = reactive({
  [CATEGORY_FEE_TYPE[CATEGORY_CODE_MAP.ZU_CHE]]: [],
  [CATEGORY_FEE_TYPE[CATEGORY_CODE_MAP.YI_ZU_DAI_GOU]]: [],
  [CATEGORY_FEE_TYPE[CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI]]: [],
})

const yaJinObj = reactive({
  fundType: FEE_CODE_MAP.YA_JIN,
  isConfirm: false,
  amount: formModel.depositReceivedVO?.depositAmount || '',
  payMode: PAY_MODE.DISPOSABLE, // 一次性
  isSelectScheme: true,
  advancePayment: 2, // 发车前收款：2-收取全部
  items: [
    {
      dueDate: '',
      endCycleDate: '',
      planAmount: formModel.depositReceivedVO?.depositAmount || '',
      remarks: '',
      startCycleDate: '',
    },
  ],
})

// 商城单默认的租赁合同模板信息
const defaultTemplate = ref({})
const emit = defineEmits(['updateData', 'clearDriverInfo', 'updateProcessConfig', 'updateAIResultInfo'])

// 获取门店列表
const getStoreOptions = async () => {
  const { code, data } = await storeList({
    pageSize: 1000,
  })
  if (code === 1) {
    storeOptions.value = data.items
  }
}
// 获取租赁方案列表并给方案赋值（主要是车牌、门店、租赁类型变更时调用）
const getPlansAndSetPlanId = async (cityCode) => {
  if (!props.isECommerce) {
    await getPlanList(cityCode)
    setPlanId()
  }
}

// 获取租赁方案列表
const getPlanList = async (cityCode) => {
  const tempCityCode = cityCode || formModel.cityCode
  const { code, data } = await getLeasingSchemeConfigListAll({
    state: 1,
    orderType: 1,
    rentCategory: formModel.rentCategory,
    modelId: formModel.modelId,
    cityCodes: tempCityCode ? [tempCityCode] : [],
  })
  if (code === 1) {
    const temp = data || []
    planOptions.value = [{ id: 0, name: '自定义' }, ...temp]
  }
}
// 给租赁方案赋值（获取列表第一项）
const setPlanId = () => {
  let currentPlan = {}
  // 存在非自定义方案时，取第一条（可能是上次使用或者最新创建）
  if (planOptions.value.length > 1) {
    currentPlan = planOptions.value[1]
  } else {
    currentPlan = planOptions.value[0]
  }
  // 当前为自定义租赁方案，之前为非自定义方案时，清空表单数据
  if (currentPlan.id === 0 && formModel.planId !== 0) {
    clearFormData()
  }
  updateFormModelData({
    planId: currentPlan.id,
  })
  // 获取租赁方案详情
  if (currentPlan.id) {
    getPlanDetail({
      planId: currentPlan.id,
    })
  }
}
// 门店选中时，获取门店对应城市编码
const storeChanged = (storeId) => {
  const selectedStore = storeOptions.value.find((item) => item.id === storeId)
  nextTick(() => {
    updateFormModelData({ cityCode: selectedStore.cityCode })
    // 门店变更，获取租赁方案列表
    if (planIdEnabled.value) {
      getPlansAndSetPlanId(selectedStore.cityCode)
    }
  })
}

// 方案选中时，获取方案详情
const planChanged = async (planId) => {
  clearFormData()
  if (planId) {
    getPlanDetail({ planId })
  } else {
    defaultTemplate.value = {
      id: '',
      name: '',
    }
  }
}
const getPlanDetail = async (params) => {
  let depositParams = {}
  if (props.isRenew) {
    depositParams = generateGetPlanDetailsParams()
  }
  const { data } = await getRentPlanConfig({
    ...params,
    startDate: formModel.startDate,
    ...depositParams,
  })
  // 给租赁起始日、租期、赠送天数、收款方式、租赁合同模板
  updateFormModelData({
    rentPeriod: data.rentPeriod,
    presentDays: data.presentDays || 0,
    payMode: data.payMode,
    rentPeriodType: data.rentPeriodType,
    payPlanFee: data.payPlanFee,
    contractTemplateId: data.contractTemplateId,
    planId: data.planId,
    cityCodes: data.cityCodes,
    orderAccruedPlans: data.orderAccruedPlans,
  })

  defaultTemplate.value = {
    id: data.contractTemplateId,
    name: data.contractTemplateName,
  }
  // 重新请求合同起始日期
  getContractEndDate({
    startDate: formModel.startDate,
    rentPeriod: data.rentPeriod,
    rentPeriodType: data.rentPeriodType,
    presentDays: formModel.presentDays,
  })
  nextTick(() => {
    // 租期、收款方式、租赁合同模版重新校验
    formRef.value?.validateField('planId')
    formRef.value?.validateField('rentPeriod')
    formRef.value?.validateField('payMode')
    contractTemplateDialogRef.value?.validateForm?.()
  })
  if (!CATEGORY_FEE_TYPE[data.rentCategory]) {
    Sentry.captureException('详情接口未返回租赁类别')
    return
  }
  const someFeeList = feeList[CATEGORY_FEE_TYPE[data.rentCategory]]
  if (!someFeeList || !someFeeList.length) {
    queryFeeList().then((list) =>
      setFeeItemArr(list, data.orderAccruedPlans))
  } else {
    setFeeItemArr(someFeeList, data.orderAccruedPlans)
  }
}
// 获取费项列表
const queryFeeList = async () => {
  feeTableData.value = []
  const { rentCategory } = formModel
  if (!rentCategory) {
    return []
  }
  const someFeeList =
  feeList[CATEGORY_FEE_TYPE[rentCategory]]
  if (!someFeeList || !someFeeList.length) {
    const res = await store.dispatch('getFeeList', {
      type: CATEGORY_FEE_TYPE[rentCategory],
    })
    feeList[CATEGORY_FEE_TYPE[rentCategory]] = res.data || []
    return res.data || []
  }
  return someFeeList
}
const setFeeItemArr = (list, orderPlanFeeList) => {
  const safeOrderPlanFeeList = Array.isArray(orderPlanFeeList) ? orderPlanFeeList : []
  const feeData = safeOrderPlanFeeList.reduce(onSetFee(list), [])
  updateFormModelData({
    orderAccruedPlans: feeData,
  })
  feeTableData.value = feeData
  emit('updateData', feeTableData.value)
}
// 租赁类型更改
const rentCategoryChanged = () => {
  // 租赁类型变更，获取租赁方案列表
  if (planIdEnabled.value) {
    getPlansAndSetPlanId()
  }
  nextTick(() => {
    queryFeeList().then((feeListArr) => addRequiredFee(feeListArr))
    updateFormModelData({
      payMode: '',
      planId: '',
      payPlanFee: null,
      rentPeriod: '',
      rentPeriodType: RENT_PERIOD_TYPE.MONTH,
      startStopDate: [],
    })
    formRef.value?.validateField('payMode')
  })
}

// 重新请求合同起止日期并生成支付计划
const getContractDataAndGetPlans = async (params) => {
  if (isGetEndDate.value) {
    Message.error('正在生成支付计划，请稍等')
    return
  }
  isGetEndDate.value = true
  emit('updateProcessConfig', {
    isGetEndDate: isGetEndDate.value,
  })
  await getContractEndDate(params)
  isGetEndDate.value = false
  emit('updateProcessConfig', {
    isGetEndDate: isGetEndDate.value,
  })
  if (formModel.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
    const payPlanFee = await props.getDriverCooperFormData()
    if (payPlanFee) {
      reGeneratePayPlan(payPlanFee)
    }
  } else if (formModel.orderAccruedPlans.length) {
    reGeneratePayPlan(formModel.orderAccruedPlans)
  }
}
const startDateChange = (val) => {
  // 使用删除键删除起始日
  if (!val) {
    updateFormModelData({
      startDate: val,
      endDate: '',
    })
    formModel.startStopDate = []
    return
  }
  // 解决偶现选中值但无法回显的问题
  updateFormModelData({
    startDate: val,
    endDate: '',
  })
  getContractDataAndGetPlans({
    startDate: val,
    rentPeriod: formModel.rentPeriod,
    rentPeriodType: formModel.rentPeriodType,
    presentDays: formModel.presentDays,
  })
}
const clearFormData = () => {
  nextTick(() => {
    updateFormModelData({
      payMode: '',
      contractTemplateId: '',
      presentDays: 0,
      rentPeriod: '',
      rentPeriodType: RENT_PERIOD_TYPE.MONTH,
      orderAccruedPlans: [],
      payPlanFee: null,
      startStopDate: [],
      endDate: '',
      cityCodes: [],
    })
    // 清空模版
    defaultTemplate.value = {
      id: '',
      name: '',
    }
    // 清空租赁列表
    feeTableData.value = []
    initFeeList([])
    emit('clearDriverInfo')
  })
}
// 新建门店跳转
const goToCreateStore = () => {
  quick('click', 'personal_sign_contract_add_store')
  trackClick('personal_sign_contract_add_store')
  const newWindow = window.open('/companyNew/company/storeManage/add?scene=2', '_blank')
  const currentWindow = window

  if (newWindow) {
    newWindow.addEventListener('beforeunload', () => {
      setTimeout(() => {
        currentWindow.focus()
      }, 100)
    })
  }
}

// 新增门店后，重新请求门店列表，并且选中刚才新增的门店
const handleAddStore = async (data) => {
  if (data) {
    await getStoreOptions()
    let cityCode = ''
    const selectedStore = storeOptions.value.find((item) => item.id === data)
    if (!selectedStore) {
      // 通过门店详情获取
      const { data: detailData } = await storeDetail({ id: data })
      cityCode = detailData.storeVO.cityCode
    } else {
      cityCode = selectedStore.cityCode
    }
    updateFormModelData({ cityCode, storeId: data })
    if (planIdEnabled.value) {
      getPlansAndSetPlanId(cityCode)
    }
  }
}
const communication = ref(null)

// 判断租期是正整数且在范围内
const rentPeriodValidate = (value) => {
  const valid = (typeof value === 'number' &&
    isFinite(value) &&
    !isNaN(value) &&
    Math.floor(value) === value &&
    value > 0)
  const maxNum = formModel.rentPeriodType === RENT_PERIOD_TYPE.MONTH ? 12 : 30
  return valid && value <= maxNum
}

const rentPeriodChange = async (val) => {
  if (!val.trim() && !rentPeriodValidate(val)) return
  getContractDataAndGetPlans({
    rentPeriodType: formModel.rentPeriodType,
    rentPeriod: val,
    startDate: formModel.startDate,
    presentDays: formModel.presentDays,
  })
}

const payModeChange = () => {
  nextTick(() => {
    updateFormModelData({
      orderAccruedPlans: [],
      payPlanFee: null,
    })
    // 清空租赁列表
    feeTableData.value = []
    initFeeList([])
    emit('clearDriverInfo')
  })
}
const rentPeriodTypeChange = () => {
  nextTick(() => {
    const data = {
      rentPeriod: '',
      payMode: '',
    }
    if (payModeList.value.length === 1 && !isECommerce.value) {
      data.payMode = payModeList.value[0].value
    }
    updateFormModelData({
      ...data,
      payPlanFee: null,
      orderAccruedPlans: [],
    })
  })
  feeTableData.value = []
  initFeeList([])
  emit('clearDriverInfo')
}

// 获取合同结束日期
const getContractEndDate = async (formData) => {
  const {
    rentPeriodType,
    rentPeriod,
    startDate,
    endDate,
    presentDays,
  } = formData
  if (!startDate || !rentPeriod) {
    return
  }
  if (endDate) {
    return updateFormModelData({ startStopDate: [startDate, endDate] })
  }
  const { data } = await calculateContractEndData({
    startDate,
    endDate,
    rentPeriodType,
    rentPeriod,
    presentDays,
  })
  updateFormModelData({ startStopDate: [startDate, data.endDate] })
}

/**
 * 重新生成支付计划（加入队列串行执行）
 * @param {Array} plans 费项计划数组
 * @returns {Promise} 队列执行结果
 */
const reGeneratePayPlan = async (plans) => {
  // 防止传入空计划
  if (!plans || plans.length === 0) {
    console.log('无有效计划，无需加入队列')
    return plans
  }
  let task = null
  // 包装为队列任务函数（无参数，避免闭包问题）
  if (formModel.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
    task = () => processDriverRules(plans)
  } else {
    task = () => processPayPlanTask(plans)
  }
  // 添加到队列并返回Promise
  return payPlanQueue.value.enqueue(task).catch((error) => {
    Message.error('支付计划生成失败')
    throw error // 允许外部捕获错误
  })
}

// 重新生成司机合作模式的规则
const processDriverRules = async (payPlanFee) => {
  const { code, data } = await payPlanPreview({
    ...payPlanFee,
    startDate: formModel.startDate, // 租赁周期开始时间
    endDate: formModel.startStopDate[1], // 租赁周期结束时间
  })
  if (code === 1) {
    updateFormModelData({
      payPlanFee: {
        ...payPlanFee,
        ...data,
      },
    })
  }
}

// 重新生成支付计划：将结果回写到原始plans数组中
const processPayPlanTask = async (plans) => {
  console.log('原始支付计划:', plans)
  // 1. 过滤有效计划（非后置费项、非押金、已配置完成）
  const validPlansWithIndex = plans
    .map((plan, index) => ({ ...plan, __originalIndex: index })) // 记录原始索引
    .filter((plan) => plan.payMode !== PAY_MODE.POSTPAID_ITEM)
    .filter((plan) => plan.fundType !== FEE_CODE_MAP.YA_JIN)
    .filter((plan) => plan.isConfirm)

  if (validPlansWithIndex.length === 0) {
    console.log('无有效支付计划需处理')
    return plans
  }
  const startTime = Date.now()
  // 2. 批量处理每个计划（串行执行，确保顺序）
  for (const plan of validPlansWithIndex) {
    await processSinglePlan(plan, plans)
  }
  // 3. 处理完成后更新状态
  initFeeList(plans)
  // 埋点统计生成支付计划时间
  quick('click', 'personal_sign_contract_regenerate', {
    type: formModel.rentCategory,
    planAccount: validPlansWithIndex.length,
    time: Date.now() - startTime,
    queueLength: payPlanQueue.value.getLength(),
  })
  trackClick('personal_sign_contract_regenerate', {
    type: formModel.rentCategory,
    planAccount: validPlansWithIndex.length,
    time: Date.now() - startTime,
    queueLength: payPlanQueue.value.getLength(),
  })
  console.log('支付计划处理完成，剩余队列长度:', payPlanQueue.value.getLength())
  return plans
}

// 处理单个计划：串行执行两个请求，并将结果回写到原始plans数组
const processSinglePlan = async (plan, originalPlans) => {
  const { __originalIndex, ...params } = plan // 解构出原始索引，剩余为业务参数
  const originalPlan = originalPlans[__originalIndex] // 定位原始计划对象

  // 1. 构建请求参数
  const commonParams = {
    rentPlanFeeType: params.fundType ?? '',
    bizType: 10,
    planId: formModel.planId ?? null,
    startTime: formModel.startStopDate?.[0] ?? '',
    endTime: formModel.startStopDate?.[1] ?? '',
    customerDueDate: params.customerDueDate ?? '',
    payMode: params.payMode,
  }

  let payPlanParams = {}
  if (params.payPlanType === RENT_TYPE.FIXEDRENT) {
    payPlanParams = {
      amountType: Number(params.amountType) || 0,
      amount: params.amount ?? 0,
    }
  } else if (params.payPlanType === RENT_TYPE.DYNAMICRENT) {
    payPlanParams = {
      payPlanType: params.payPlanType,
      spId: params.spId ?? '',
      dynamicType: params.dynamicType ?? '',
      dynamicList: params.dynamicList ?? [],
    }
  }

  const postParams = {
    ...commonParams,
    ...payPlanParams,
    rentCategory: formModel.rentCategory ?? '',
  }
  if (params.payMode === PAY_MODE.STAGES && params.fundType === FEE_CODE_MAP.YA_JIN) {
    postParams.depositInstallmentList = params.depositInstallmentList ?? []
  }
  /**
  * fundType费项类型为租金/其他 并且 payMode付款类型为周付、自然月付、满月付的时加上保留几位小数字段
  */
  if (
    (params.fundType === FEE_CODE_MAP.ZU_JIN ||
    params.fundType === FEE_CODE_MAP.OTHERS) &&
    (params.payMode === PAY_MODE.WEEK ||
    params.payMode === PAY_MODE.FULL_MOON ||
    params.payMode === PAY_MODE.NATURAL_MONTH)
  ) {
    postParams.amountAccuracy = params.amountAccuracy
  }


  try {
    // 2. 第一个请求：获取预览计划
    const { data: planData } = await getPreviewedPlan(postParams)
    const { accruedPlanList = [] } = planData || {}

    // 处理计划列表
    const processedPlans = accruedPlanList.map((item, index) => ({
      ...item,
      num: index + 1,
      accruedCycle: [item.startCycleDate, item.endCycleDate].filter(Boolean),
    }))

    // 3. 第二个请求：获取统计数据（基于第一个请求的参数或结果）
    const { data: statsData } = await getAccruedPlanStatistic({ accruedPlanList: processedPlans })
    const { totalCycle = 0, totalAmount = 0 } = statsData || {}

    // 4. 将两个请求的结果回写到原始计划对象中
    Object.assign(originalPlan, {
      // 第一个请求的结果
      items: processedPlans, // 处理后的计划列表
      totalCycle,
      totalAmount, // 总金额
      // 可选：标记处理状态
      isProcessed: true,
    })

    console.log(`计划[${params.fundType}]处理完成，已回写结果`)
    return originalPlan // 返回更新后的计划
  } catch (error) {
    // 错误时也回写状态
    Object.assign(originalPlan, {
      isProcessed: false,
      error: error.message,
    })
    console.error(`计划[${params.fundType}]处理失败:`, error.message)
    throw error // 继续抛出错误，确保Promise.all能捕获
  }
}
// 是否押金平移radio更改
const depositChange = (val) => {
  quick('click', 'personal_sign_contract_deposit', {
    value: val,
  })
  trackClick('personal_sign_contract_deposit', {
    value: val,
  })
  if (formModel.planId && formModel.startStopDate.length > 0) {
    getPlanDetail({
      ...generateGetPlanDetailsParams(),
      planId: formModel.planId,
      startDate: formModel.startDate,
    })
  } else {
    queryFeeList().then((feeArr) => addRequiredFee(feeArr))
  }
}
const generateGetPlanDetailsParams = () => {
  const params = {
    depositTransfer: formModel.isTranDeposit,
    oldOrderId: formModel.relatedOrderId,
  }
  return params
}

const addRequiredFee = (someFeeList) => {
  // 过滤必填费项
  const requiredFee = someFeeList.filter((item) => item.required) || []
  let formatFees = requiredFee.map((i) => {
    const item = {}
    item.fundType = i.code
    item.name = i.name
    item.required = i.required
    item.toast = i.toast
    item.isConfirm = false
    return item
  })
  // 若类型选的是【以租代购】,(首付款/租金)和(全款)是互斥关系，table默认展示 首付款/租金，全款需过滤掉
  if (Number(formModel.rentCategory) === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
    // 15-全款
    formatFees = formatFees.filter((i) => Number(i.fundType) !== FEE_CODE_MAP.QUAN_KUAN)
  }
  // 若需要平移原定单押金，需配置
  if (formModel.isTranDeposit) {
    // 因为订单续约创建新订单时，类别可以自定义选择。而新模式下【以租代购】只有首付款，没有押金。所以在选择确定押金平移时：
    // 1、原订单的押金处理逻辑不变，仍然是生成押金的付款单把账给平了
    // 2、新订单下，把原订单的押金对应金额，对应到费项“首付款”上。
    //  ● 收款方式为一次性，不可编辑
    //  ● 收款金额：平移原订单的押金金额，不可编辑
    //  ● 缴款日：默认为收款起始日，且不可编辑
    //  ● 发车前收款：收取全部，不可编辑
    // 3、列表上仍然展示“以租代购模式下，首付款为必填项。请点击配置首付款的支付计划”的文案，需要操作者点击配置按指引确认完后回填信息。
    // 基于以上产品需求变更，所以如果为以租代购，将押金code转成首付款的code值
    if (Number(formModel.rentCategory) === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
      yaJinObj.fundType = FEE_CODE_MAP.SHOU_FU_KUAN
    } else {
      yaJinObj.fundType = FEE_CODE_MAP.YA_JIN
    }
    formatFees = formatFees.map((item) => {
      let newItem = item
      if (newItem.fundType === yaJinObj.fundType) {
        newItem = Object.assign({}, newItem, yaJinObj)
      }
      return newItem
    })
  }
  feeTableData.value = formatFees
  emit('updateData', feeTableData.value)
}

const validateForm = async () => {
  if (!formRef.value) return false
  try {
    const contractValid = await contractTemplateDialogRef.value.validateForm()
    const valid = await formRef.value.validate()
    return contractValid && valid
  } catch (error) {
    if (!planIdEnabled.value) {
      formRef.value.clearValidate('planId')
    }
    return false
  }
}

// 更新formModel的值
const updateFormModelData = (data) => {
  miniStore.dispatch({
    type: 'BATCH_UPDATE_FIELD',
    payload: {
      updates: {
        step0: data,
      },
    },
  })
}
const setTemplateIdAndAIResultInfo = (info) => {
  updateFormModelData({
    contractTemplateId: info.templateId,
  })
}

// 下一步是否可用
const nextStepEnable = () => {
  if (isRequestPlans.value === 1 || isGetEndDate.value) {
    Message.error('正在生成支付计划，请稍等')
    return false
  }
  return true
}
// 保存租赁方案成功后，直接在租赁方案列表中添加这一项，防止租赁方案闪一下方案id的情况
const setPlanOptions = (obj) => {
  planOptions.value.splice(1, 0, obj)
}
// 设置初始费项
const initFeeList = (orderAccruedPlans) => {
  if (orderAccruedPlans.length === 0) {
    queryFeeList().then((feeListArr) => addRequiredFee(feeListArr))
  } else {
    const someFeeList = feeList[CATEGORY_FEE_TYPE[formModel.rentCategory]]
    if (!someFeeList || !someFeeList.length) {
      queryFeeList().then((list) =>
        setFeeItemArr(list, orderAccruedPlans))
    } else {
      setFeeItemArr(someFeeList, orderAccruedPlans)
    }
  }
}
const initFormData = async () => {
  // 如果方案id且方案名称均存在，则直接拼接租赁方案列表，不去请求，减少租赁方案那一项出现数字的可能
  if (formModel.planId === 0) {
    planOptions.value = [{ name: '自定义', id: 0 }]
  } else if (formModel.planId && formModel.planName) {
    planOptions.value = [
      { name: formModel.planName, id: formModel.planId },
    ]
  }
  await initSetCityCode()
  getPlanList()
  // 返回上一步时，不能请求initConfig接口
  if (formModel.planId && !formModel.prevNext) {
    getPlanDetail({
      planId: formModel.planId,
      productSnapshotId: formModel.productSnapshotId,
    })
  }
  // 给模版初始化
  defaultTemplate.value = {
    id: formModel.contractTemplateId,
    name: formModel.contractTemplateName,
  }
  // 设置押金平移金额
  if (props.isRenew) {
    yaJinObj.amount = formModel.depositReceivedVO?.depositAmount || ''
    yaJinObj.items[0].planAmount = formModel.depositReceivedVO?.depositAmount || ''
  }
  await getContractEndDate(formModel)
  initFeeList(formModel.orderAccruedPlans || [])
  // 把表单校验去除
  formRef.value?.clearValidate()
}
const ORDER_MAP = {
  [PAY_MODE.FULL_MOON]: 1,
  [PAY_MODE.NATURAL_MONTH]: 2,
  [PAY_MODE.WEEK]: 3,
  [PAY_MODE.DAY]: 4,
}
const DRIVER_ORDER_MAP = {
  [PAY_MODE_BY_DRIVER_COOPERATION.MONTH]: 1,
  [PAY_MODE_BY_DRIVER_COOPERATION.WEEK]: 2,
  [PAY_MODE_BY_DRIVER_COOPERATION.DAY]: 3,
}
const compareByCustomOrder = (a, b, MAP, field = 'value') => {
  // 获取两个对象的目标字段值
  const valueA = a[field]
  const valueB = b[field]

  // 从映射中获取权重（未在映射中的值默认最低优先级）
  const weightA = MAP[valueA] ?? Infinity
  const weightB = MAP[valueB] ?? Infinity

  // 按权重升序排序（权重小的排在前面）
  return weightA - weightB
}
// 获取收款方式列表
const payModeList = computed(() => {
  const { rentCategory, rentPeriodType } = formModel
  if (!rentCategory || !rentPeriodType) {
    return []
  }
  // 租赁类型为纯租或者以租代购，租期类型为月时，收款方式为：月付（自然月）月付（满月）周付 日付
  if (rentCategory === CATEGORY_CODE_MAP.ZU_CHE || rentCategory === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
    return useDictParseList(PAY_MODE_TEXT).sort((a, b) => compareByCustomOrder(a, b, ORDER_MAP))
  }

  // 租赁类型为司机合作模式，租期类型为月时，收款方式为：月结、周结、日结
  if (rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
    return useDictParseList(PAY_MODE_BY_DRIVER_COOPERATION_TEXT).sort((a, b) => compareByCustomOrder(a, b, DRIVER_ORDER_MAP))
  }
  return []
})

// 收款方式以纯文本展示
const payModeText = computed(() => {
  // 商城单纯文本展示
  if (isECommerce.value) {
    return {
      isText: true,
      text: PAY_MODE_TEXT[formModel.payMode],
    }
  }
  // 收款方式列表只有一项时纯文本展示
  if (payModeList.value.length === 1) {
    return {
      isText: true,
      text: payModeList.value[0].label,
    }
  }
  return {
    isText: false,
    text: '',
  }
})

// 判断是否为商城单(绑车)
const isECommerce = computed(() => {
  return formModel.source === ORDER_SOURCE.E_COMMERCE && !props.isRenew
})

const disableDeposit = computed(() => {
  // 以租代购或者司机合作模式，无论是否原单有押金，均不可选择平移押金
  const { SI_JI_HE_ZUO_MO_SHI, YI_ZU_DAI_GOU } = CATEGORY_CODE_MAP
  const { rentCategory } = formModel
  if ([YI_ZU_DAI_GOU, SI_JI_HE_ZUO_MO_SHI].includes(rentCategory)) {
    return true
  }
  return !formModel.depositReceivedVO?.flag
})

const startPickOptions = computed(() => {
  return {
    disabledDate: (time) => {
      const prevOrderEndDate = formModel.contractEndDate
      return props.isRenew ? moment(time.getTime()).isBefore(moment(prevOrderEndDate).add(1, 'days').format('yyyy-MM-DD')) : false
    },
  }
})

// 已收押金文案
const depositReceivedText = computed(() => {
  if (isEmpty(formModel.depositReceivedVO)) {
    return ''
  }
  return `（已收押金：${Math.max(formModel.depositReceivedVO.depositReceived, 0.00)}元）`
})

// 续约时租赁起始日的默认值
/*
  下一期最近可用的收款"起始"日期字符串，格式为 yyyy-MM-dd
  续约时，开始日期为上一期结束日期+1天
  返回上一步时，开始日期取服务端返回的startDate
  正常签约提车时，开始日期取当天
*/
const defaultStartDate = computed(() => {
  const { contractEndDate, startDate, prevNext } = formModel
  if (contractEndDate && !prevNext) {
    return moment(contractEndDate).add(1, 'days').format('yyyy-MM-DD')
  }
  // 返回上一步时，取startDate
  if (prevNext && startDate) {
    return moment(startDate).format('yyyy-MM-DD')
  }
  return moment().format('yyyy-MM-DD')
})

// 租赁方案是否可编辑
const planIdEnabled = computed(() => {
  const {
    modelId,
    storeId,
    rentCategory } = formModel
  return modelId && storeId && rentCategory
})

const payModeLabel = computed(() => {
  return formModel.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '结算周期' : '收款方式'
})

// 收款方式只有一项时（非商城单），收款方式默认选中
watch(() => payModeList.value, (val) => {
  if (val.length === 1 && !isECommerce.value) {
    updateFormModelData({ payMode: val[0].value })
    formRef.value.clearValidate('payMode')
  }
})
// 如果禁用平移押金选项，则一定是不平移押金，如果不禁用平移押金选项，则可以选是或否
watch(() => disableDeposit.value, (val) => {
  if (val) {
    updateFormModelData({ isTranDeposit: 0 })
  }
}, { immediate: true })

watch(() => defaultStartDate.value, (val) => {
  updateFormModelData({ startDate: val })
}, { immediate: true })

watch(
  () => payPlanQueue.value.getLength(),
  (length) => {
    if (length > 0 && isRequestPlans.value !== 1) {
      isRequestPlans.value = 1 // 有排队任务时，标记为执行中
    } else if (length === 0 && payPlanQueue.value.getProcessingStatus() === false) {
      isRequestPlans.value = 2 // 队列空且无执行中任务，标记为空闲
    }
    emit('updateProcessConfig', {
      isGetRentPlan: isRequestPlans.value === 1,
    })
  },
  { immediate: true },
)

// 在组件卸载时移除监听
onUnmounted(() => {
  if (communication.value) {
    communication.value.off('add_store', handleAddStore)
    communication.value.destroy()
  }
  payPlanQueue.value.clear() // 清空未执行的队列任务
})

onMounted(async () => {
  store.dispatch('getPaymentMethods', { type: 'rentCategory' })
  if (formModel.storeId && formModel.storeName) {
    storeOptions.value = [{ id: formModel.storeId, name: formModel.storeName }]
  }
  if (!props.isRenew && !isECommerce.value) {
    initFeeList(formModel.orderAccruedPlans || [])
    // 新增门店
    communication.value = new WindowCommunication('person_sign_contract')
    communication.value.on('add_store', handleAddStore)
  } else {
    initFeeList(formModel.orderAccruedPlans || [])
  }
  // 监听队列状态变更：status=是否执行中，queueLength=剩余队列长度
  payPlanQueue.value.onStatusChange = (status, queueLength) => {
    if (status || queueLength > 0) {
      isRequestPlans.value = 1 // 执行中（或有排队任务）
    } else {
      isRequestPlans.value = 2 // 空闲（无执行+无排队）
    }
  }
  initSetCityCode()
})

const endDatePickerOptions = computed(() => ({
  disabledDate: (time) => {
    if (!formModel.startDate) return false
    return moment(time).isBefore(moment(formModel.startDate))
  },
}))


const handleSelectEndDate = () => {
  // 切换前清除当前字段的校验结果
  const currentField = formModel.isEndDateMode ? 'endDate' : 'rentPeriod'
  formRef.value?.clearValidate(currentField)

  if (formModel.isEndDateMode) {
    updateFormModelData({
      rentPeriod: '',
    })
  } else {
    updateFormModelData({
      endDate: '',
    })
  }

  updateFormModelData({
    isEndDateMode: !formModel.isEndDateMode,
  })
}

const onEndDateChange = (val) => {
  if (!formModel.startDate || !val) return


  calculateDays({
    startDate: formModel.startDate,
    endDate: val,
  }).then((res) => {
    const { code, data } = res
    if (code === 1) {
      updateFormModelData({
        startStopDate: [formModel.startDate, val],
        rentPeriod: data.days,
        rentPeriodType: RENT_PERIOD_TYPE.DAY,
      })
      getContractDataAndGetPlans({
        startStopDate: [formModel.startDate, val],
        endDate: val,
      })
    }
  })
}

const initSetCityCode = async () => {
  await getStoreOptions()
  // 获取城市编码
  if (formModel.storeId) {
    const selectedStore = storeOptions.value.find((item) => item.id === formModel.storeId)
    if (!selectedStore) {
      // 通过门店详情获取
      const { data } = await storeDetail({ id: formModel.storeId })
      const { cityCode } = data.storeVO
      updateFormModelData({ cityCode })
    } else {
      updateFormModelData({ cityCode: selectedStore.cityCode })
    }
  }
}
defineExpose({
  validateForm,
  getPlansAndSetPlanId,
  initFormData,
  nextStepEnable,
  setPlanOptions,
})
</script>

<style lang="scss" scoped>
.mt16 { margin-top: 16px; }
.form-box {
  ::v-deep .el-form-item .el-form-item__label {
    width: 100%;
    justify-content: flex-start;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-date-editor {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  &__periods {
    display: flex;
    width:100%;
    &__input {
      flex: 1;
      ::v-deep .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    &__select {
      width: 70px;
      margin-top: 32px;
      ::v-deep .el-input__inner {
        background: #F7F8FA;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
      }
    }
  }
  .form-box__deposit {
    width: 100%;
    white-space: nowrap;
  }
}
</style>
<style lang="scss">
.plan-rent-select-list {
  .el-select-dropdown__wrap {
    width: 100% !important;
    .qs-select-dropdown__item {
      max-width: 100% !important;
    }
  }
}
.select-recent-mode {
  font-size: 12px;
  margin-left: 5px;
  position: absolute;
  right: 0;
}
</style>
